import { datadogRum } from "@datadog/browser-rum";
import type { App } from "vue";
import type { MutationPayload } from "vuex";

export default function initializeDatadogRum(app: App) {
  // disable RUM for prerender.io and screenshot lambda
  const { userAgent } = navigator;
  if (
    userAgent.includes("Prerender") ||
    userAgent.includes("RocketScreenshot")
  ) {
    return;
  }

  if (
    import.meta.env.VITE_ENABLE_DATADOG_RUM === "true" &&
    !import.meta.env.VITE_PLAYWRIGHT_CI &&
    import.meta.env.STORYBOOK !== "true"
  ) {
    datadogRum.init({
      applicationId: "1dd0d394-46c4-4ba9-a4d6-7f9573328686",
      clientToken: "pubccb30e3c6063a9c2d79ca083d27d0716",
      site: "datadoghq.com",
      service: "touchscreen_site",
      env: import.meta.env.VITE_ENV,
      version: import.meta.env.VITE_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      actionNameAttribute: "data-dd",
      beforeSend(event) {
        if (event.context) {
          // this will allow us to easily create a CMS mode filter in Datadog
          const {
            isAuth,
            showCMS,
            styleID,
            organizationName,
            touchScreen,
            clientID,
          } = app.config.globalProperties.$store.state;
          // eslint-disable-next-line no-param-reassign
          event.context.isCmsMode = showCMS;
          // eslint-disable-next-line no-param-reassign
          event.context.isAuth = isAuth;
          // eslint-disable-next-line no-param-reassign
          event.context.siteId = styleID;
          // eslint-disable-next-line no-param-reassign
          event.context.organizationName = organizationName;
          // eslint-disable-next-line no-param-reassign
          event.context.isTouchscreen = touchScreen;
          // eslint-disable-next-line no-param-reassign
          event.context.collectionID = clientID;
        }
        return true;
      },
    });

    const unsubscribe = app.config.globalProperties.$store.subscribe(
      (
        mutation: MutationPayload,
        state: { userEmail?: string; isAdmin?: boolean; isInternal?: boolean }
      ) => {
        // we rely on setAuth instead of setUser because it is called after all the user data has been committed
        if (mutation.type === "setAuth") {
          const { userEmail, isAdmin, isInternal } = state;
          if (userEmail) {
            datadogRum.setUser({
              email: userEmail,
              role:
                (isInternal && "internal") || (isAdmin && "admin") || "user",
            });
            // Unsubscribe so that we no longer listen for further mutations
            unsubscribe();
          }
        }
        // const ddUser = datadogRum.getUser(); // for debugging
      }
    );
  }
}
